<template>
	<div>
		<el-row class="stat-table" v-loading="loading">
			<el-col :span="12">
				<ul>
					<li>
						<label for>工单：</label>
						<span>{{ data.work_order_code }}</span>
					</li>
					<li>
						<label for>良品率：</label>
						<span>{{ data.yield_rate }}</span>
					</li>
					<li>
						<label for>机器状态：</label>
						<span>{{ data.statusText }}</span>
					</li>
					<li>
						<label for>检测状态：</label>
						<span>{{ data.checkStatus }}</span>
					</li>
					<li>
						<label for>开机时间：</label>
						<span>{{ data.startTime }}</span>
					</li>
					<li>
						<label for>剩余时间：</label>
						<span>{{ data.remaining }}</span>
					</li>
					<li>
						<label for>下一工单：</label>
						<span>{{ result }}</span>
					</li>
				</ul>
			</el-col>
			<el-col :span="12">
				<ul>
					<li v-for="(item, index) in techInfo" :key="index">
						<label for>{{ item.name }}：</label>
						<span>{{ item.value }}</span>
					</li>
				</ul>
			</el-col>
			<el-col :span="24">
				<div class="progress">
					<label>进度：</label>
					<el-progress :text-inside="true" :stroke-width="24" :percentage="progressValue" status="exception"></el-progress>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import jtService from '@/service/jtService'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	export default {
		data() {
			return {
				data: {},
				techInfo: [],
				loading: false,
				timer: null,
				result: '',
			}
		},
		props: {
			jt_id: {
				type: String,
			},
		},
		computed: {
			monitorTime() {
				var value = 5
				var lv = localStorage.getItem('MonitorTime')
				if (lv) {
					value = lv
				}

				return value * 1000
			},
			progressValue() {
				if (this.data.progress > 100) {
					return 100
				}

				return this.data.progress
			},
		},
		watch: {
			jt_id(val) {
				console.log('jt_id', val)
				clearInterval(this.timer)
				this.loading = true
				this.loadJtStatus(val)
				this.timer = setInterval(() => {
					this.loadJtStatus(this.jt_id)
				}, this.monitorTime)
			},
		},
		methods: {
			async showDE(id, code) {
				var that = this
				var job_orders = await jobOrderRequest.queryAll({ jt_id: id }, { code: 1, plan_begin_time: 1 }, { plan_begin_time: 1 })
				job_orders.forEach(function(k, v) {
					if (k['code'] == code) {
						if (v == job_orders.length - 1) {
							that.result = job_orders[0]['code']
						} else {
							that.result = job_orders[v + 1]['code']
						}
					}
				})
				//return this.result
			},
			async loadJtStatus(jt_id) {
				this.data = await jtService.getJTStatus(jt_id)

				console.log(this.data)

				console.log('deviceStatusDate', this.data)
				this.techInfo = await jtService.getJTTechParams(jt_id, this.data.tech_group_id)
				this.loading = false

				this.showDE(this.jt_id, this.data.work_order_code)
			},
		},
		async created() {
			this.loading = true
			await this.loadJtStatus(this.jt_id)

			this.timer = setInterval(async () => {
				await this.loadJtStatus(this.jt_id)
			}, this.monitorTime)
		},
		destroyed() {
			clearInterval(this.timer)
		},
	}
</script>

<style scoped>
	.stat-table {
		padding: 0 1rem;
	}
	.stat-table ul {
		margin: 0;
		padding: 0;
	}

	.stat-table ul li {
		list-style: none;
		padding: 3px 5px;
		line-height: 23px;
		margin-bottom: 10px;
		font-size: 16px;
	}

	.stat-table ul li span {
		color: #aaa;
	}

	.progress {
		margin: 20px 0;
		border-top: 1px #eee solid;
		padding: 20px 0;
	}

	.progress label {
		font-size: 12px;
		margin-bottom: 10px;
		display: block;
		color: #aaa;
	}
</style>
